
import { useState, useEffect } from "react";
import { useProveedores } from "../../Services/Proveedores";




export const useProveedoresRME = () => {

 const { getProveedores} =useProveedores();
  const [proveedores, setProveedores] = useState([]);
  const [loadingProveedores, setLoading] = useState(false);
  const [errorProveedores, setError] = useState(null);

  const FetchGetProveedores = async () => {
  setLoading(true);
  setError(null);

  try {
    const data = await getProveedores();

    setProveedores(data);
  } catch (error) {
    console.error("ERROR COMPLETO:", error);

    const msg =
      error.response?.data?.message || "Error al cargar proveedores";

    setError(msg);
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
     FetchGetProveedores();
  }, []);

  return {
    proveedores,
    loadingProveedores,
    errorProveedores,
    refetchProveedores: FetchGetProveedores,
  };
};